export const environment = {
  production: true,
  env: 'production',
  // apiUrl: 'http://localhost:8080',
  // apiUrl: 'https://monitorar-hmg-backend.mma.gov.br',
  apiUrl: 'https://monitorar-backend.mma.gov.br',
  // integradorApiUrl: 'https://integrador-backend-hmg.mma.gov.br',
  integradorApiUrl: 'https://integrador-backend.mma.gov.br',
  integradorApiVersion: 'v1',
  // bundleId: 'br.gov.mma.dev.monitorarcidadao',
  bundleId: 'br.gov.mma.monitorar',
  urlAtualizacao: 'https://www.mbamobi.com.br/mma/monitorar/',
  firebaseConfig: {
    apiKey: 'AIzaSyC8Qghn5_MZvgtFWYh4-TkM4RTwkGvbx84',
    authDomain: 'mma-monitorar.firebaseapp.com',
    projectId: 'mma-monitorar',
    storageBucket: 'mma-monitorar.firebasestorage.app',
    messagingSenderId: '830459886470',
    appId: '1:830459886470:web:0775344fe947ab73d20a07',
    vapidKey: 'BHbSlYTZgfsv80AQO6suF-JS2Gh02Eqv1GARGOmeG2kbrnIzKsMDZhr7LeA4NeJVlDFBBFGqmrWLUMdDmuT5UsA'
  }
};
